import Dashboard from "../../../components/dashboard/Dashboard";
import LoboCard from "../../../components/LoboCard";
import { Square, Circle } from "lucide-react";

import { useSubscriptionContext } from "../../../hooks/useSubscriptionContext";
import { useAuthContext } from "../../../hooks/useAuthContext";
import { useEffect, useState } from "react";
import Loading from "../../../components/Loading";
import axios from "axios";
import { useTranslation } from "react-i18next";

import loboMatchIcon from "../../../assets/images/LOBOMATCH.png";
import loboLiteIcon from "../../../assets/images/LOBOLITE.png";
import loboCancelIcon from "../../../assets/images/LOBOCANCEL.png";
import loboBoostIcon from "../../../assets/images/LOBOBOOST.png";
import loboXsellIcon from "../../../assets/images/LOBOXSELL.png";


const Module = () => {
  const { t } = useTranslation();

  const data = [
    {
      name: "loboMATCH",
      subscribe: "lobo_match",
      description: t("managementMatch"),
      active: true,
      icon: <img src={loboMatchIcon} alt={`lobo-match`} className="h-8 w-8" />,
      permission: "manage_whatsapp",
    },
    {
      name: "loboLITE",
      subscribe: "lobo_lite",
      description: t("simplified_reservation_management"),
      active: true,
      icon: <img src={loboLiteIcon} alt={`lobo-match`} className="h-8 w-8" />,
      permission: "lobolite",
    },
    {
      name: "loboCANCEL",
      subscribe: "lobo_cancel",
      description: t("cancellation_management"),
      active: false,
      icon: <img src={loboCancelIcon} alt={`lobo-match`} className="h-8 w-8" />,
      permission: "lobocancel",
    },
    {
      name: "loboBOOST",
      subscribe: "lobo_boost",
      description: t("performance_optimizer"),
      active: true,
      icon: <img src={loboBoostIcon} alt={`lobo-match`} className="h-8 w-8" />,
      permission: "loboboost",
    },
    {
      name: "loboXSELL",
      subscribe: "lobo_xsell",
      description: t("cross_selling_services"),
      active: false,
      icon: <img src={loboXsellIcon} alt={`lobo-match`} className="h-8 w-8" />,
      permission: "loboxsell",
    },
  ];
  const { user } = useAuthContext();
  const clubDetails = JSON.parse(localStorage.getItem("club_details"));
  const { subscriptions, loading } = useSubscriptionContext();
  const [isLoading, setIsLoading] = useState(true);
  const [newModules, setNewModules] = useState([]);

  useEffect(() => {
    const checkAuthorization = async () => {
      if (!user) {
        setIsLoading(false);
        // console("AAAAAAAAAAAAAAA")
        return;
      }

      if (user.role == "club_manager" || user.role == "cloud_admin" || user.role == "super_admin") {
        setNewModules(data);
        setIsLoading(false);
        return;
      }

      try {
        if (!clubDetails?.club_id) {
          setIsLoading(false);
          return;
        }

        const rolesResponse = await axios.get(`/api/roles/user-roles`, {
          params: { userId: user.userId },
          headers: {
            Authorization: `Bearer ${user.token}`,
            "Content-Type": "application/json",
          },
        });

        const clubRoles = rolesResponse.data.filter(
          (role) => role.club_id == clubDetails.club_id
        );

        const permissionsResponses = await Promise.all(
          clubRoles.map((role) =>
            axios.get(`/api/roles/role-permissions/${role.id}`, {
              headers: {
                Authorization: `Bearer ${user.token}`,
                "Content-Type": "application/json",
              },
            })
          )
        );

        const allPermissions = new Set();
        permissionsResponses.forEach((response) => {
          response.data.forEach((p) => allPermissions.add(p.permission));
        });

        const filteredFeatures = data.filter((feature) =>
          allPermissions.has(feature.permission)
        );

        setNewModules(filteredFeatures);
      } catch (error) {
        console.error("Authorization check failed:", error);
      }
      setIsLoading(false);
    };

    checkAuthorization();
  }, [user]);

  if (loading || isLoading) return <Loading />;
  return (
    <div className="flex flex-col w-full">
      <div className="w-full px-4">
        <h1 className="pt-6 pb-1 text-xl font-bold text-primary">Módulos Contratados</h1>
        <hr className=" h-[1.5px] bg-primary mb-6" />
        {newModules.map(
          ({ name, description, active, icon, subscribe }, index) => {
            return (
              <LoboCard
                key={index}
                name={name}
                description={description}
                active={active}
                icon={icon}
                subscribe={subscribe}
              />
            );
          }
        )}
      </div>
      <div className="w-full">
        <Dashboard />
      </div>
    </div>
  );
};

export default Module;
